const LoaderInfiniteLoop = ({
    size = 100
}) => {
    return (
    <>
      <center>
      <style>{`
        .logo {
          overflow: visible;
        }

        .blue-outline {
          fill: transparent;
          stroke: #253786;
          stroke-width: 3;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 1800;
          stroke-dashoffset: 1800;
          animation: drawBlue 2s infinite;
        }

        .orange-outline {
          fill: transparent;
          stroke: #E95C0C;
          stroke-width: 3;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 1800;
          stroke-dashoffset: 1800;
          animation: drawOrange 2s infinite;
        }

        .blue-fill {
          fill: #253786;
          opacity: 0;
          animation: fillBlue 2s infinite;
        }

        .orange-fill {
          fill: #E95C0C;
          opacity: 0;
          animation: fillOrange 2s infinite;
        }

        .eye {
          opacity: 0;
          transform-box: fill-box;
          transform-origin: center;
        }

        .eye-blue {
          fill: #253786;
          animation: eyePop 2s infinite;
        }

        .eye-orange-1 {
          fill: #E95C0C;
          animation: eyePop 2s infinite 0.15s;
        }

        .eye-orange-2 {
          fill: #E95C0C;
          animation: eyePop 2s infinite 0.3s;
        }

        @keyframes eyePop {
          0% {
            opacity: 0;
            transform: scale(0);
          }

          10% {
            opacity: 1;
            transform: scale(1.35);
          }

          18% {
            opacity: 1;
            transform: scale(1);
          }

          100% {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes drawBlue {
          0%, 20% {
            stroke-dashoffset: 1800;
          }

          55% {
            stroke-dashoffset: 0;
          }

          100% {
            stroke-dashoffset: 0;
          }
        }

        @keyframes drawOrange {
          0%, 35% {
            stroke-dashoffset: 1800;
          }

          75% {
            stroke-dashoffset: 0;
          }

          100% {
            stroke-dashoffset: 0;
          }
        }

        @keyframes fillBlue {
          0%, 50% {
            opacity: 0;
          }

          60%, 100% {
            opacity: 1;
          }
        }

        @keyframes fillOrange {
          0%, 70% {
            opacity: 0;
          }

          80%, 100% {
            opacity: 1;
          }
        }
      `}</style>

      
        <svg
        className="logo"
        viewBox="80 240 420 320"
        preserveAspectRatio="xMidYMid meet"
        style={{
            width: "100%",
            height: "auto",
            maxWidth: `${size}px`,
            display: "block"
        }}
        >

        {/* Contour bleu */}

        <path
          className="blue-outline"
          d="M171.18,337.63c27.55-47.62,106.98-50.1,132.64,0.21c18.36,31.33,9.91,66.41,4.4,106.74
          c-0.36,2.63-1.48,6.38,1.24,7.79c2.72-0.22,26.12-7.48,27.47-12.15c5.02-17.4,8.2-35.43,8.4-53.56
          c0.16-14.97-1.75-30.02-6.38-44.28c-4.02-12.39-10.1-24.1-18.17-34.34c-7.48-9.49-16.61-17.65-26.88-24.02
          c-10.01-6.21-21.05-10.7-32.52-13.33c-11.47-2.63-23.37-3.39-35.08-2.27c-11.92,1.14-23.65,4.24-34.57,9.17
          c-11.43,5.16-21.93,12.3-30.98,20.98c-9.95,9.54-18.09,20.88-24.32,33.16c-7.27,14.34-11.94,29.89-14.58,45.72"
        />

        {/* Remplissage bleu */}

        <path
          className="blue-fill"
          d="M171.18,337.63c27.55-47.62,106.98-50.1,132.64,0.21c18.36,31.33,9.91,66.41,4.4,106.74
          c-0.36,2.63-1.48,6.38,1.24,7.79c2.72-0.22,26.12-7.48,27.47-12.15c5.02-17.4,8.2-35.43,8.4-53.56
          c0.16-14.97-1.75-30.02-6.38-44.28c-4.02-12.39-10.1-24.1-18.17-34.34c-7.48-9.49-16.61-17.65-26.88-24.02
          c-10.01-6.21-21.05-10.7-32.52-13.33c-11.47-2.63-23.37-3.39-35.08-2.27c-11.92,1.14-23.65,4.24-34.57,9.17
          c-11.43,5.16-21.93,12.3-30.98,20.98c-9.95,9.54-18.09,20.88-24.32,33.16c-7.27,14.34-11.94,29.89-14.58,45.72"
        />

        {/* Contour orange */}

        <path
          className="orange-outline"
          d="M464.25,332.26c-0.51-4.69-35.64,20.75-38.02,24.09
          c-3.29,56.91-31.38,175.4-97.63,175.4
          c-84.63,0-87.77-115.8-71.34-161.07
          c-9.2-6.48-22.73-31.24-27-21.33
          c-16.35,37.95-18.68,90.65-9.38,133.65
          c30.64,95.44,109.11,99.28,157.56,71.44
          C439.86,519.12,469.41,380.07,464.25,332.26z"
        />

        {/* Remplissage orange */}

        <path
          className="orange-fill"
          d="M464.25,332.26c-0.51-4.69-35.64,20.75-38.02,24.09
          c-3.29,56.91-31.38,175.4-97.63,175.4
          c-84.63,0-87.77-115.8-71.34-161.07
          c-9.2-6.48-22.73-31.24-27-21.33
          c-16.35,37.95-18.68,90.65-9.38,133.65
          c30.64,95.44,109.11,99.28,157.56,71.44
          C439.86,519.12,469.41,380.07,464.25,332.26z"
        />

        {/* Yeux d'abord */}

        <circle
          className="eye eye-blue"
          cx="193"
          cy="377"
          r="8"
        />

        <circle
          className="eye eye-orange-1"
          cx="282"
          cy="392"
          r="8"
        />

        <circle
          className="eye eye-orange-2"
          cx="373"
          cy="401"
          r="8"
        />
      </svg>
      </center>
    </>
  );
}

LoaderInfiniteLoop.propTypes = {};

export default LoaderInfiniteLoop;